<template>
  <div id="app">
    <HeaderLine></HeaderLine>
    <router-view/>
    <SystemMessage></SystemMessage>
  </div>
</template>

<script>
import SystemMessage from './components/SystemMessage.vue'
import HeaderLine from './components/HeaderLine.vue'

export default {
    components: {
        SystemMessage,
        HeaderLine
    },
    created: function () {
        let self = this
        this.axios.interceptors.response.use(undefined, function (err) {
            return new Promise(() => {
                if (err.response.status === 401) {
                    self.$store.dispatch('auth/logout')
                }
                throw err
            })
        })

        const user = localStorage.getItem('user')
        if (user) {
            this.$store.commit('auth/auth_success', JSON.parse(user))
            /* this.$store.dispatch('getUser').catch(() => {
                this.$router.push('/login')
            }) */
        }
    }
}
</script>

<style lang="scss">
@import './assets/style/reset.css';
@import './assets/style/vars.scss';
@import './assets/style/login.scss';
@import './assets/style/header.scss';
@import './assets/style/layout.scss';
@import './assets/style/interactiveElements.scss';
@import './assets/style/table.scss';
@import './assets/style/filter.scss';
@import './assets/style/settings.scss';
@import './assets/style/card.scss';
@import './assets/style/form.scss';
@import './assets/style/shedule.scss';
@import './assets/style/config.scss';
@import './assets/style/price.scss';
@import './assets/style/popup.scss';

* {
  box-sizing:border-box;
}
html {
  min-width:1024px;
  overflow-x:hidden;
}
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size:16px;
}
</style>